import { useLocation } from "react-router"

export const useIsContentPage = () => {
  const loc = useLocation();
  return loc.pathname !== '/';
}
